import flatpickr from "flatpickr";

const cache = {};

export default function fxRates( node ) {
	const picker = node.querySelector('.fx-rates__datepicker');
	const table  = node.querySelector('.fx-rates__table');
	const error  = node.querySelector('.fx-rates__error');
	const api  = node.dataset.api;
	const maxRefreshes = 14;

	let selectedDate;
	let refreshCount = 0;

	if ( ! picker || ! table ) {
		return;
	}

	const formatDate = ( dateObj ) => {
		const year  = dateObj.getFullYear();
		let   month = dateObj.getMonth() + 1;
		let   date  = dateObj.getDate();

		if ( month < 10 ) {
			month = `0${month}`;
		}

		if ( date < 10 ) {
			date = `0${date}`;
		}

		return `${year}-${month}-${date}`;
	}

	const render = ( data ) => {
		// remove non-header row
		Array.from( table.querySelectorAll('.fx-rates__row') ).slice(1).forEach( node => node.parentNode.removeChild(node) );

		if ( data.error_message ) {
			node.classList.add('fx-rates--error');
			error.innerHTML = data.error_message;
		} else if ( Array.isArray( data ) ) {
			data.forEach( record => {
				const row = document.createElement('tr');
				row.className = 'fx-rates__row';
				row.innerHTML = `
					<td>${ record.currency }</td>
					<td>${ record.buying_cash }</td>
					<td>${ record.buying }</td>
					<td>${ record.selling }</td>
				`.trim();
				table.appendChild(row);
			} );
		}
	}

	const refresh = ( date ) => {

		if ( cache[ date ] ) {
			console.info( 'cache', date, cache[ date ] );

			render( cache[ date ] );
			refreshCount = 0;
			node.classList.remove('fx-rates--loading');
			node.classList.remove('fx-rates--error');
			return;
		}

		node.classList.remove('fx-rates--error');
		node.classList.add('fx-rates--loading');

		window.fetch( `${api}/${date || ''}` )
			.then( response => {
				if ( 404 === response.status ) {
					if ( refreshCount < maxRefreshes ) {
						refreshCount++;
						selectedDate.setDate( selectedDate.getDate() - 1 );
						refresh( formatDate( selectedDate ) );
						return { refreshing: true };
					}
				}

				if ( [ 200, 304 ].indexOf( response.status ) > -1 ) {
					const body = response.json();
					refreshCount = 0;

					if ( body.message ) {
						throw new Error( body.message );
					}

					return body;
				} else {
					throw new Error( `${response.status} ${response.statusText}` );
				}
			} )
			.then( data => {
				if ( ! data.refreshing ) {
					cache[ date ] = data;
					render( data );
				}

				return data;
			} )
			.catch( ( err ) => {
				node.classList.add('fx-rates--error');

				if ( err.message ) {
					error.innerHTML = `There was an error loading exchange rates: ${err.message}`;
				}
			} )
			.finally( () => {
				if ( refreshCount === 0 ) {
					node.classList.remove('fx-rates--loading');
				} else if ( refreshCount >= maxRefreshes ) {
					node.classList.add('fx-rates--error');
					node.classList.remove('fx-rates--loading');
				}
			} );
	}

	flatpickr(
		picker,
		{
			dateFormat: 'm/d/Y',
			maxDate: 'today',
			defaultDate: 'today',
			onChange: ( selectedDates, dateStr, instance ) => {
				selectedDate = selectedDates[0];
				refresh( formatDate( selectedDate ) );
			},
			onReady: ( selectedDates, dateStr, instance ) => {
				selectedDate = selectedDates[0];

				if ( table.querySelectorAll('tr').length < 2 ) {
					selectedDate.setDate( selectedDate.getDate() - 1 );
					refresh( formatDate( selectedDate ) );
				}
			}
		}
	);
}

document.addEventListener( 'DOMContentLoaded', () => document.querySelectorAll( '.fx-rates' ).forEach( fxRates ) );
